// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.31.1
// source: SashAdmin/TeachingOrchestration.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Empty } from "../google/protobuf/empty";

export const protobufPackage = "sashadmin";

export interface StartSessionRequest {
  streamId: string;
  deviceId: string;
  userId: string;
  institutionId?: string | undefined;
}

export interface SessionStartResponse {
  streamSessionId: string;
  roomId: string;
  publishToken: string;
  wsUrl: string;
  success: boolean;
  errorMessage: string;
}

export interface StopSessionRequest {
  streamSessionId: string;
  userId: string;
  institutionId?: string | undefined;
}

export interface StopSessionResponse {
  stopped: boolean;
  errorMessage: string;
}

export interface JoinSessionRequest {
  streamSessionId: string;
  deviceId: string;
  userId: string;
  institutionId?: string | undefined;
}

export interface SessionConnectResponse {
  streamSessionId: string;
  roomId: string;
  subscribeToken: string;
  wsUrl: string;
  success: boolean;
  errorMessage: string;
}

export interface LeaveSessionRequest {
  streamSessionId: string;
  userId: string;
  institutionId?: string | undefined;
}

export interface LeaveSessionResponse {
  left: boolean;
  errorMessage: string;
}

export interface GetActiveSessionRequest {
  deviceId: string;
  userId: string;
  institutionId?: string | undefined;
}

export interface StreamSessionDTO {
  id: string;
  streamId: string;
  labId: string;
  status: string;
  startedAt: string;
  stoppedAt: string;
  recordingUrl: string;
  success: boolean;
  errorMessage: string;
}

export interface CheckAccessRequest {
  userId: string;
  deviceId: string;
  institutionId?: string | undefined;
}

export interface AccessResponse {
  canJoin: boolean;
  canPublish: boolean;
  canAdminStop: boolean;
  reason: string;
  success: boolean;
  errorMessage: string;
}

export interface ForcePingObserversRequest {
  streamSessionId: string;
  userId: string;
  institutionId?: string | undefined;
}

export interface ForcePingObserversResponse {
  success: boolean;
  errorMessage: string;
}

export interface SetMutePresenterRequest {
  streamSessionId: string;
  isMuted: boolean;
  institutionId?: string | undefined;
}

export interface SetMutePresenterResponse {
  success: boolean;
  errorMessage: string;
}

export interface GetActiveSessionsRequest {
  userId: string;
  /** Optional filter by specific lab */
  labId: string;
  /** Page number (1-based) */
  pageNumber: number;
  /** Items per page (default 10) */
  pageSize: number;
  institutionId?: string | undefined;
}

export interface GetActiveSessionsResponse {
  sessions: ActiveSessionInfo[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  success: boolean;
  errorMessage: string;
}

export interface ActiveSessionInfo {
  streamSessionId: string;
  labId: string;
  labName: string;
  streamTitle: string;
  presenterUserId: string;
  presenterName: string;
  startedAt: string;
  /** Number of active observers */
  observersCount: number;
  deviceId: string;
}

export interface HeartbeatSessionRequest {
  streamSessionId: string;
  institutionId?: string | undefined;
}

function createBaseStartSessionRequest(): StartSessionRequest {
  return { streamId: "", deviceId: "", userId: "", institutionId: undefined };
}

export const StartSessionRequest = {
  encode(message: StartSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamId !== "") {
      writer.uint32(18).string(message.streamId);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.userId !== "") {
      writer.uint32(34).string(message.userId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(42).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartSessionRequest {
    return {
      streamId: isSet(object.streamId) ? globalThis.String(object.streamId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: StartSessionRequest): unknown {
    const obj: any = {};
    if (message.streamId !== "") {
      obj.streamId = message.streamId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<StartSessionRequest>): StartSessionRequest {
    return StartSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartSessionRequest>): StartSessionRequest {
    const message = createBaseStartSessionRequest();
    message.streamId = object.streamId ?? "";
    message.deviceId = object.deviceId ?? "";
    message.userId = object.userId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseSessionStartResponse(): SessionStartResponse {
  return { streamSessionId: "", roomId: "", publishToken: "", wsUrl: "", success: false, errorMessage: "" };
}

export const SessionStartResponse = {
  encode(message: SessionStartResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(10).string(message.streamSessionId);
    }
    if (message.roomId !== "") {
      writer.uint32(18).string(message.roomId);
    }
    if (message.publishToken !== "") {
      writer.uint32(26).string(message.publishToken);
    }
    if (message.wsUrl !== "") {
      writer.uint32(34).string(message.wsUrl);
    }
    if (message.success !== false) {
      writer.uint32(40).bool(message.success);
    }
    if (message.errorMessage !== "") {
      writer.uint32(50).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SessionStartResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSessionStartResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.roomId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.publishToken = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.wsUrl = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SessionStartResponse {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
      publishToken: isSet(object.publishToken) ? globalThis.String(object.publishToken) : "",
      wsUrl: isSet(object.wsUrl) ? globalThis.String(object.wsUrl) : "",
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: SessionStartResponse): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    if (message.publishToken !== "") {
      obj.publishToken = message.publishToken;
    }
    if (message.wsUrl !== "") {
      obj.wsUrl = message.wsUrl;
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<SessionStartResponse>): SessionStartResponse {
    return SessionStartResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SessionStartResponse>): SessionStartResponse {
    const message = createBaseSessionStartResponse();
    message.streamSessionId = object.streamSessionId ?? "";
    message.roomId = object.roomId ?? "";
    message.publishToken = object.publishToken ?? "";
    message.wsUrl = object.wsUrl ?? "";
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseStopSessionRequest(): StopSessionRequest {
  return { streamSessionId: "", userId: "", institutionId: undefined };
}

export const StopSessionRequest = {
  encode(message: StopSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(18).string(message.streamSessionId);
    }
    if (message.userId !== "") {
      writer.uint32(26).string(message.userId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(34).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopSessionRequest {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: StopSessionRequest): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<StopSessionRequest>): StopSessionRequest {
    return StopSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopSessionRequest>): StopSessionRequest {
    const message = createBaseStopSessionRequest();
    message.streamSessionId = object.streamSessionId ?? "";
    message.userId = object.userId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseStopSessionResponse(): StopSessionResponse {
  return { stopped: false, errorMessage: "" };
}

export const StopSessionResponse = {
  encode(message: StopSessionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.stopped !== false) {
      writer.uint32(8).bool(message.stopped);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopSessionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.stopped = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopSessionResponse {
    return {
      stopped: isSet(object.stopped) ? globalThis.Boolean(object.stopped) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: StopSessionResponse): unknown {
    const obj: any = {};
    if (message.stopped !== false) {
      obj.stopped = message.stopped;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<StopSessionResponse>): StopSessionResponse {
    return StopSessionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StopSessionResponse>): StopSessionResponse {
    const message = createBaseStopSessionResponse();
    message.stopped = object.stopped ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseJoinSessionRequest(): JoinSessionRequest {
  return { streamSessionId: "", deviceId: "", userId: "", institutionId: undefined };
}

export const JoinSessionRequest = {
  encode(message: JoinSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(18).string(message.streamSessionId);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.userId !== "") {
      writer.uint32(34).string(message.userId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(42).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): JoinSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoinSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoinSessionRequest {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: JoinSessionRequest): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<JoinSessionRequest>): JoinSessionRequest {
    return JoinSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<JoinSessionRequest>): JoinSessionRequest {
    const message = createBaseJoinSessionRequest();
    message.streamSessionId = object.streamSessionId ?? "";
    message.deviceId = object.deviceId ?? "";
    message.userId = object.userId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseSessionConnectResponse(): SessionConnectResponse {
  return { streamSessionId: "", roomId: "", subscribeToken: "", wsUrl: "", success: false, errorMessage: "" };
}

export const SessionConnectResponse = {
  encode(message: SessionConnectResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(10).string(message.streamSessionId);
    }
    if (message.roomId !== "") {
      writer.uint32(18).string(message.roomId);
    }
    if (message.subscribeToken !== "") {
      writer.uint32(26).string(message.subscribeToken);
    }
    if (message.wsUrl !== "") {
      writer.uint32(34).string(message.wsUrl);
    }
    if (message.success !== false) {
      writer.uint32(40).bool(message.success);
    }
    if (message.errorMessage !== "") {
      writer.uint32(50).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SessionConnectResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSessionConnectResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.roomId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.subscribeToken = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.wsUrl = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SessionConnectResponse {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      roomId: isSet(object.roomId) ? globalThis.String(object.roomId) : "",
      subscribeToken: isSet(object.subscribeToken) ? globalThis.String(object.subscribeToken) : "",
      wsUrl: isSet(object.wsUrl) ? globalThis.String(object.wsUrl) : "",
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: SessionConnectResponse): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.roomId !== "") {
      obj.roomId = message.roomId;
    }
    if (message.subscribeToken !== "") {
      obj.subscribeToken = message.subscribeToken;
    }
    if (message.wsUrl !== "") {
      obj.wsUrl = message.wsUrl;
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<SessionConnectResponse>): SessionConnectResponse {
    return SessionConnectResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SessionConnectResponse>): SessionConnectResponse {
    const message = createBaseSessionConnectResponse();
    message.streamSessionId = object.streamSessionId ?? "";
    message.roomId = object.roomId ?? "";
    message.subscribeToken = object.subscribeToken ?? "";
    message.wsUrl = object.wsUrl ?? "";
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseLeaveSessionRequest(): LeaveSessionRequest {
  return { streamSessionId: "", userId: "", institutionId: undefined };
}

export const LeaveSessionRequest = {
  encode(message: LeaveSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(18).string(message.streamSessionId);
    }
    if (message.userId !== "") {
      writer.uint32(26).string(message.userId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(34).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LeaveSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveSessionRequest {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: LeaveSessionRequest): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<LeaveSessionRequest>): LeaveSessionRequest {
    return LeaveSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LeaveSessionRequest>): LeaveSessionRequest {
    const message = createBaseLeaveSessionRequest();
    message.streamSessionId = object.streamSessionId ?? "";
    message.userId = object.userId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseLeaveSessionResponse(): LeaveSessionResponse {
  return { left: false, errorMessage: "" };
}

export const LeaveSessionResponse = {
  encode(message: LeaveSessionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.left !== false) {
      writer.uint32(8).bool(message.left);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LeaveSessionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveSessionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.left = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveSessionResponse {
    return {
      left: isSet(object.left) ? globalThis.Boolean(object.left) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: LeaveSessionResponse): unknown {
    const obj: any = {};
    if (message.left !== false) {
      obj.left = message.left;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<LeaveSessionResponse>): LeaveSessionResponse {
    return LeaveSessionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LeaveSessionResponse>): LeaveSessionResponse {
    const message = createBaseLeaveSessionResponse();
    message.left = object.left ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseGetActiveSessionRequest(): GetActiveSessionRequest {
  return { deviceId: "", userId: "", institutionId: undefined };
}

export const GetActiveSessionRequest = {
  encode(message: GetActiveSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deviceId !== "") {
      writer.uint32(18).string(message.deviceId);
    }
    if (message.userId !== "") {
      writer.uint32(26).string(message.userId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(34).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetActiveSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveSessionRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: GetActiveSessionRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetActiveSessionRequest>): GetActiveSessionRequest {
    return GetActiveSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetActiveSessionRequest>): GetActiveSessionRequest {
    const message = createBaseGetActiveSessionRequest();
    message.deviceId = object.deviceId ?? "";
    message.userId = object.userId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseStreamSessionDTO(): StreamSessionDTO {
  return {
    id: "",
    streamId: "",
    labId: "",
    status: "",
    startedAt: "",
    stoppedAt: "",
    recordingUrl: "",
    success: false,
    errorMessage: "",
  };
}

export const StreamSessionDTO = {
  encode(message: StreamSessionDTO, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.streamId !== "") {
      writer.uint32(18).string(message.streamId);
    }
    if (message.labId !== "") {
      writer.uint32(26).string(message.labId);
    }
    if (message.status !== "") {
      writer.uint32(34).string(message.status);
    }
    if (message.startedAt !== "") {
      writer.uint32(42).string(message.startedAt);
    }
    if (message.stoppedAt !== "") {
      writer.uint32(50).string(message.stoppedAt);
    }
    if (message.recordingUrl !== "") {
      writer.uint32(58).string(message.recordingUrl);
    }
    if (message.success !== false) {
      writer.uint32(64).bool(message.success);
    }
    if (message.errorMessage !== "") {
      writer.uint32(74).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StreamSessionDTO {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreamSessionDTO();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.labId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.status = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.startedAt = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.stoppedAt = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.recordingUrl = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StreamSessionDTO {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      streamId: isSet(object.streamId) ? globalThis.String(object.streamId) : "",
      labId: isSet(object.labId) ? globalThis.String(object.labId) : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      startedAt: isSet(object.startedAt) ? globalThis.String(object.startedAt) : "",
      stoppedAt: isSet(object.stoppedAt) ? globalThis.String(object.stoppedAt) : "",
      recordingUrl: isSet(object.recordingUrl) ? globalThis.String(object.recordingUrl) : "",
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: StreamSessionDTO): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.streamId !== "") {
      obj.streamId = message.streamId;
    }
    if (message.labId !== "") {
      obj.labId = message.labId;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.startedAt !== "") {
      obj.startedAt = message.startedAt;
    }
    if (message.stoppedAt !== "") {
      obj.stoppedAt = message.stoppedAt;
    }
    if (message.recordingUrl !== "") {
      obj.recordingUrl = message.recordingUrl;
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<StreamSessionDTO>): StreamSessionDTO {
    return StreamSessionDTO.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StreamSessionDTO>): StreamSessionDTO {
    const message = createBaseStreamSessionDTO();
    message.id = object.id ?? "";
    message.streamId = object.streamId ?? "";
    message.labId = object.labId ?? "";
    message.status = object.status ?? "";
    message.startedAt = object.startedAt ?? "";
    message.stoppedAt = object.stoppedAt ?? "";
    message.recordingUrl = object.recordingUrl ?? "";
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseCheckAccessRequest(): CheckAccessRequest {
  return { userId: "", deviceId: "", institutionId: undefined };
}

export const CheckAccessRequest = {
  encode(message: CheckAccessRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(34).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CheckAccessRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckAccessRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckAccessRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: CheckAccessRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<CheckAccessRequest>): CheckAccessRequest {
    return CheckAccessRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CheckAccessRequest>): CheckAccessRequest {
    const message = createBaseCheckAccessRequest();
    message.userId = object.userId ?? "";
    message.deviceId = object.deviceId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseAccessResponse(): AccessResponse {
  return { canJoin: false, canPublish: false, canAdminStop: false, reason: "", success: false, errorMessage: "" };
}

export const AccessResponse = {
  encode(message: AccessResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.canJoin !== false) {
      writer.uint32(8).bool(message.canJoin);
    }
    if (message.canPublish !== false) {
      writer.uint32(16).bool(message.canPublish);
    }
    if (message.canAdminStop !== false) {
      writer.uint32(24).bool(message.canAdminStop);
    }
    if (message.reason !== "") {
      writer.uint32(34).string(message.reason);
    }
    if (message.success !== false) {
      writer.uint32(40).bool(message.success);
    }
    if (message.errorMessage !== "") {
      writer.uint32(50).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AccessResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccessResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.canJoin = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.canPublish = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.canAdminStop = reader.bool();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.reason = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AccessResponse {
    return {
      canJoin: isSet(object.canJoin) ? globalThis.Boolean(object.canJoin) : false,
      canPublish: isSet(object.canPublish) ? globalThis.Boolean(object.canPublish) : false,
      canAdminStop: isSet(object.canAdminStop) ? globalThis.Boolean(object.canAdminStop) : false,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: AccessResponse): unknown {
    const obj: any = {};
    if (message.canJoin !== false) {
      obj.canJoin = message.canJoin;
    }
    if (message.canPublish !== false) {
      obj.canPublish = message.canPublish;
    }
    if (message.canAdminStop !== false) {
      obj.canAdminStop = message.canAdminStop;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<AccessResponse>): AccessResponse {
    return AccessResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AccessResponse>): AccessResponse {
    const message = createBaseAccessResponse();
    message.canJoin = object.canJoin ?? false;
    message.canPublish = object.canPublish ?? false;
    message.canAdminStop = object.canAdminStop ?? false;
    message.reason = object.reason ?? "";
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseForcePingObserversRequest(): ForcePingObserversRequest {
  return { streamSessionId: "", userId: "", institutionId: undefined };
}

export const ForcePingObserversRequest = {
  encode(message: ForcePingObserversRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(18).string(message.streamSessionId);
    }
    if (message.userId !== "") {
      writer.uint32(26).string(message.userId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(34).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ForcePingObserversRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForcePingObserversRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ForcePingObserversRequest {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: ForcePingObserversRequest): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<ForcePingObserversRequest>): ForcePingObserversRequest {
    return ForcePingObserversRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ForcePingObserversRequest>): ForcePingObserversRequest {
    const message = createBaseForcePingObserversRequest();
    message.streamSessionId = object.streamSessionId ?? "";
    message.userId = object.userId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseForcePingObserversResponse(): ForcePingObserversResponse {
  return { success: false, errorMessage: "" };
}

export const ForcePingObserversResponse = {
  encode(message: ForcePingObserversResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ForcePingObserversResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseForcePingObserversResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ForcePingObserversResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: ForcePingObserversResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<ForcePingObserversResponse>): ForcePingObserversResponse {
    return ForcePingObserversResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ForcePingObserversResponse>): ForcePingObserversResponse {
    const message = createBaseForcePingObserversResponse();
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseSetMutePresenterRequest(): SetMutePresenterRequest {
  return { streamSessionId: "", isMuted: false, institutionId: undefined };
}

export const SetMutePresenterRequest = {
  encode(message: SetMutePresenterRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(18).string(message.streamSessionId);
    }
    if (message.isMuted !== false) {
      writer.uint32(32).bool(message.isMuted);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(42).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetMutePresenterRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMutePresenterRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isMuted = reader.bool();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMutePresenterRequest {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      isMuted: isSet(object.isMuted) ? globalThis.Boolean(object.isMuted) : false,
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: SetMutePresenterRequest): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.isMuted !== false) {
      obj.isMuted = message.isMuted;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<SetMutePresenterRequest>): SetMutePresenterRequest {
    return SetMutePresenterRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetMutePresenterRequest>): SetMutePresenterRequest {
    const message = createBaseSetMutePresenterRequest();
    message.streamSessionId = object.streamSessionId ?? "";
    message.isMuted = object.isMuted ?? false;
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseSetMutePresenterResponse(): SetMutePresenterResponse {
  return { success: false, errorMessage: "" };
}

export const SetMutePresenterResponse = {
  encode(message: SetMutePresenterResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.errorMessage !== "") {
      writer.uint32(18).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetMutePresenterResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMutePresenterResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMutePresenterResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: SetMutePresenterResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<SetMutePresenterResponse>): SetMutePresenterResponse {
    return SetMutePresenterResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetMutePresenterResponse>): SetMutePresenterResponse {
    const message = createBaseSetMutePresenterResponse();
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseGetActiveSessionsRequest(): GetActiveSessionsRequest {
  return { userId: "", labId: "", pageNumber: 0, pageSize: 0, institutionId: undefined };
}

export const GetActiveSessionsRequest = {
  encode(message: GetActiveSessionsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.labId !== "") {
      writer.uint32(26).string(message.labId);
    }
    if (message.pageNumber !== 0) {
      writer.uint32(32).int32(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      writer.uint32(40).int32(message.pageSize);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(50).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetActiveSessionsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveSessionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.labId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.pageNumber = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveSessionsRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      labId: isSet(object.labId) ? globalThis.String(object.labId) : "",
      pageNumber: isSet(object.pageNumber) ? globalThis.Number(object.pageNumber) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: GetActiveSessionsRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.labId !== "") {
      obj.labId = message.labId;
    }
    if (message.pageNumber !== 0) {
      obj.pageNumber = Math.round(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetActiveSessionsRequest>): GetActiveSessionsRequest {
    return GetActiveSessionsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetActiveSessionsRequest>): GetActiveSessionsRequest {
    const message = createBaseGetActiveSessionsRequest();
    message.userId = object.userId ?? "";
    message.labId = object.labId ?? "";
    message.pageNumber = object.pageNumber ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseGetActiveSessionsResponse(): GetActiveSessionsResponse {
  return { sessions: [], totalCount: 0, totalPages: 0, currentPage: 0, success: false, errorMessage: "" };
}

export const GetActiveSessionsResponse = {
  encode(message: GetActiveSessionsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.sessions) {
      ActiveSessionInfo.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalCount !== 0) {
      writer.uint32(16).int32(message.totalCount);
    }
    if (message.totalPages !== 0) {
      writer.uint32(24).int32(message.totalPages);
    }
    if (message.currentPage !== 0) {
      writer.uint32(32).int32(message.currentPage);
    }
    if (message.success !== false) {
      writer.uint32(40).bool(message.success);
    }
    if (message.errorMessage !== "") {
      writer.uint32(50).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetActiveSessionsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveSessionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.sessions.push(ActiveSessionInfo.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.totalPages = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.currentPage = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.success = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveSessionsResponse {
    return {
      sessions: globalThis.Array.isArray(object?.sessions)
        ? object.sessions.map((e: any) => ActiveSessionInfo.fromJSON(e))
        : [],
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
      totalPages: isSet(object.totalPages) ? globalThis.Number(object.totalPages) : 0,
      currentPage: isSet(object.currentPage) ? globalThis.Number(object.currentPage) : 0,
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
    };
  },

  toJSON(message: GetActiveSessionsResponse): unknown {
    const obj: any = {};
    if (message.sessions?.length) {
      obj.sessions = message.sessions.map((e) => ActiveSessionInfo.toJSON(e));
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    if (message.totalPages !== 0) {
      obj.totalPages = Math.round(message.totalPages);
    }
    if (message.currentPage !== 0) {
      obj.currentPage = Math.round(message.currentPage);
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create(base?: DeepPartial<GetActiveSessionsResponse>): GetActiveSessionsResponse {
    return GetActiveSessionsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetActiveSessionsResponse>): GetActiveSessionsResponse {
    const message = createBaseGetActiveSessionsResponse();
    message.sessions = object.sessions?.map((e) => ActiveSessionInfo.fromPartial(e)) || [];
    message.totalCount = object.totalCount ?? 0;
    message.totalPages = object.totalPages ?? 0;
    message.currentPage = object.currentPage ?? 0;
    message.success = object.success ?? false;
    message.errorMessage = object.errorMessage ?? "";
    return message;
  },
};

function createBaseActiveSessionInfo(): ActiveSessionInfo {
  return {
    streamSessionId: "",
    labId: "",
    labName: "",
    streamTitle: "",
    presenterUserId: "",
    presenterName: "",
    startedAt: "",
    observersCount: 0,
    deviceId: "",
  };
}

export const ActiveSessionInfo = {
  encode(message: ActiveSessionInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(10).string(message.streamSessionId);
    }
    if (message.labId !== "") {
      writer.uint32(18).string(message.labId);
    }
    if (message.labName !== "") {
      writer.uint32(26).string(message.labName);
    }
    if (message.streamTitle !== "") {
      writer.uint32(34).string(message.streamTitle);
    }
    if (message.presenterUserId !== "") {
      writer.uint32(42).string(message.presenterUserId);
    }
    if (message.presenterName !== "") {
      writer.uint32(50).string(message.presenterName);
    }
    if (message.startedAt !== "") {
      writer.uint32(58).string(message.startedAt);
    }
    if (message.observersCount !== 0) {
      writer.uint32(64).int32(message.observersCount);
    }
    if (message.deviceId !== "") {
      writer.uint32(74).string(message.deviceId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ActiveSessionInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveSessionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.labId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.labName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.streamTitle = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.presenterUserId = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.presenterName = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.startedAt = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.observersCount = reader.int32();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.deviceId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActiveSessionInfo {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      labId: isSet(object.labId) ? globalThis.String(object.labId) : "",
      labName: isSet(object.labName) ? globalThis.String(object.labName) : "",
      streamTitle: isSet(object.streamTitle) ? globalThis.String(object.streamTitle) : "",
      presenterUserId: isSet(object.presenterUserId) ? globalThis.String(object.presenterUserId) : "",
      presenterName: isSet(object.presenterName) ? globalThis.String(object.presenterName) : "",
      startedAt: isSet(object.startedAt) ? globalThis.String(object.startedAt) : "",
      observersCount: isSet(object.observersCount) ? globalThis.Number(object.observersCount) : 0,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
    };
  },

  toJSON(message: ActiveSessionInfo): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.labId !== "") {
      obj.labId = message.labId;
    }
    if (message.labName !== "") {
      obj.labName = message.labName;
    }
    if (message.streamTitle !== "") {
      obj.streamTitle = message.streamTitle;
    }
    if (message.presenterUserId !== "") {
      obj.presenterUserId = message.presenterUserId;
    }
    if (message.presenterName !== "") {
      obj.presenterName = message.presenterName;
    }
    if (message.startedAt !== "") {
      obj.startedAt = message.startedAt;
    }
    if (message.observersCount !== 0) {
      obj.observersCount = Math.round(message.observersCount);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create(base?: DeepPartial<ActiveSessionInfo>): ActiveSessionInfo {
    return ActiveSessionInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ActiveSessionInfo>): ActiveSessionInfo {
    const message = createBaseActiveSessionInfo();
    message.streamSessionId = object.streamSessionId ?? "";
    message.labId = object.labId ?? "";
    message.labName = object.labName ?? "";
    message.streamTitle = object.streamTitle ?? "";
    message.presenterUserId = object.presenterUserId ?? "";
    message.presenterName = object.presenterName ?? "";
    message.startedAt = object.startedAt ?? "";
    message.observersCount = object.observersCount ?? 0;
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseHeartbeatSessionRequest(): HeartbeatSessionRequest {
  return { streamSessionId: "", institutionId: undefined };
}

export const HeartbeatSessionRequest = {
  encode(message: HeartbeatSessionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.streamSessionId !== "") {
      writer.uint32(18).string(message.streamSessionId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(26).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HeartbeatSessionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeartbeatSessionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.streamSessionId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HeartbeatSessionRequest {
    return {
      streamSessionId: isSet(object.streamSessionId) ? globalThis.String(object.streamSessionId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: HeartbeatSessionRequest): unknown {
    const obj: any = {};
    if (message.streamSessionId !== "") {
      obj.streamSessionId = message.streamSessionId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<HeartbeatSessionRequest>): HeartbeatSessionRequest {
    return HeartbeatSessionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HeartbeatSessionRequest>): HeartbeatSessionRequest {
    const message = createBaseHeartbeatSessionRequest();
    message.streamSessionId = object.streamSessionId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

export type TeachingOrchestrationServiceDefinition = typeof TeachingOrchestrationServiceDefinition;
export const TeachingOrchestrationServiceDefinition = {
  name: "TeachingOrchestrationService",
  fullName: "sashadmin.TeachingOrchestrationService",
  methods: {
    startSession: {
      name: "StartSession",
      requestType: StartSessionRequest,
      requestStream: false,
      responseType: SessionStartResponse,
      responseStream: false,
      options: {},
    },
    stopSession: {
      name: "StopSession",
      requestType: StopSessionRequest,
      requestStream: false,
      responseType: StopSessionResponse,
      responseStream: false,
      options: {},
    },
    joinSession: {
      name: "JoinSession",
      requestType: JoinSessionRequest,
      requestStream: false,
      responseType: SessionConnectResponse,
      responseStream: false,
      options: {},
    },
    leaveSession: {
      name: "LeaveSession",
      requestType: LeaveSessionRequest,
      requestStream: false,
      responseType: LeaveSessionResponse,
      responseStream: false,
      options: {},
    },
    getActiveSession: {
      name: "GetActiveSession",
      requestType: GetActiveSessionRequest,
      requestStream: false,
      responseType: StreamSessionDTO,
      responseStream: false,
      options: {},
    },
    getActiveSessions: {
      name: "GetActiveSessions",
      requestType: GetActiveSessionsRequest,
      requestStream: false,
      responseType: GetActiveSessionsResponse,
      responseStream: false,
      options: {},
    },
    checkAccess: {
      name: "CheckAccess",
      requestType: CheckAccessRequest,
      requestStream: false,
      responseType: AccessResponse,
      responseStream: false,
      options: {},
    },
    forcePingObservers: {
      name: "ForcePingObservers",
      requestType: ForcePingObserversRequest,
      requestStream: false,
      responseType: ForcePingObserversResponse,
      responseStream: false,
      options: {},
    },
    setMutePresenter: {
      name: "SetMutePresenter",
      requestType: SetMutePresenterRequest,
      requestStream: false,
      responseType: SetMutePresenterResponse,
      responseStream: false,
      options: {},
    },
    heartbeatSession: {
      name: "HeartbeatSession",
      requestType: HeartbeatSessionRequest,
      requestStream: false,
      responseType: Empty,
      responseStream: false,
      options: {},
    },
  },
} as const;

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
